<template>
    <div>
        <div class="chat-body" ref="chatBody">
            <div
                v-for="(msg, index) in messages"
                :key="index"
                :class="[
                    'message-row',
                    msg.roleType === 'SELLER' ? 'agent' : 'customer',
                ]"
            >
                <div class="avatar"><i class="fa fa-user"> </i></div>
                <div class="message">{{ msg.text }}</div>
            </div>
        </div>

        <div class="chat-input">
            <input
                v-model="newMessage"
                @keyup.enter="sendMessage"
                placeholder="Write a message..."
            />
            <button @click="sendMessage">➤</button>
        </div>
    </div>
</template>

<script>
import io from "socket.io-client";
import { NIPIGE_BASE_URL } from "@/config";
import { mapState, mapGetters } from "vuex";

export default {
    components: {},
    props: {
        reviewDetail: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            loading: true,
            newMessage: "",
            messages: [],
            socket: null,
            userId: "",
            token: "",
            contextId: "", // product ID or context
            messagesId: "", // conversation ID
        };
    },
    computed: {
        ...mapState({
            chatListMsg: (state) => state.partner.chatListMsg,
        }),
        ...mapGetters({
            userInfo: "profileUpdate/GetmeTenant",
        }),
    },
    methods: {
        async initialize() {
            const { token, _id } = await this.$currentUserData;
            this.token = token;
            this.userId = _id;
            this.connectSocket();
            await this.getProductDetail();
            await this.setLastReadMessage();
            this.loading = false;
        },

        connectSocket() {
            this.socket = io(NIPIGE_BASE_URL, {
                query: `token=${this.token}`,
                path: "/notification/ws",
                transports: ["websocket"], // 'polling'- add polling for XHR
                withCredentials: true,
            });

            this.socket.on("connect", () => {
                console.log("Socket connected");
            });

            this.socket.on("new_message", (msg) => {
                console.log(msg, "MSG");
                if (msg.conversationId === this.messagesId) {
                    this.messages.push(msg);
                    this.$nextTick(this.scrollToBottom);
                    if (msg.fid !== this.userId) {
                        this.socket.emit("delivered_bs_chat_message", {
                            id: this.messagesId,
                            messageId: msg._id,
                        });
                        this.socket.emit("read_bs_chat_message", {
                            id: this.messagesId,
                            messageId: msg._id,
                        });
                    }
                    this.setLastReadMessage();
                }
            });

            this.socket.on("message_received", (data) => {
                console.log("Message received:", data);
            });

            this.socket.on("message_read", (data) => {
                console.log("Message read:", data);
            });
        },

        sendMessage() {
            if (this.newMessage.trim()) {
                this.socket.emit("send_bs_new_message", {
                    tid: this.reviewDetail.givenBy.userId,
                    contextId: this.reviewDetail.subjectId,
                    text: this.newMessage.trim(),
                });
                this.newMessage = "";
            }
        },

        scrollToBottom() {
            const chatBody = this.$refs.chatBody;
            if (chatBody) {
                chatBody.scrollTop = chatBody.scrollHeight;
            }
        },

        async setLastReadMessage() {
            const last = {
                id: this.messagesId,
                lastMessageId:
                    this.messages[this.messages.length - 1]?._id || "",
            };
            let lastRead =
                JSON.parse(localStorage.getItem("lastReadMessage")) || [];
            const index = lastRead.findIndex((i) => i.id === last.id);

            if (index !== -1) {
                lastRead[index] = last;
            } else {
                lastRead.push(last);
            }

            localStorage.setItem("lastReadMessage", JSON.stringify(lastRead));
        },

        async getProductDetail() {
            try {
                const res = await fetch(
                    `${NIPIGE_BASE_URL}/catalog/api/catalog/read/catalog/item/${this.contextId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: this.token,
                        },
                    },
                );
                const data = await res.json();
                if (res.status === 1) {
                    console.log("Product:", data.response[0]);
                    // You can display product info in UI if needed
                }
            } catch (err) {
                console.error("Product fetch error:", err);
            }
        },
        async getChatList() {
            try {
                await this.$store.dispatch("partner/fetchChatList");
            } catch (error) {
                console.error("Product fetch error:", error);
            }
            console.log(this.reviewDetail, "this.reviewDetail");
            console.log(this.chatListMsg, "this.chatListMsg");
            const chat = (this.chatListMsg.chats || []).find(
                (item) =>
                    item.contextId &&
                    item.contextId._id === this.reviewDetail.subjectId,
            );
            console.log(chat, "this.chat");
            this.messages =
                chat && Array.isArray(chat.messages) ? chat.messages : [];
            this.messagesId = this.messages[0].conversationId;
        },
    },

    mounted() {
        this.contextId = this.reviewDetail.subjectId;
        this.getChatList();
        this.initialize();
    },

    beforeDestroy() {
        if (this.socket) {
            this.socket.off("connect");
            this.socket.off("new_message");
            this.socket.off("message_received");
            this.socket.off("message_read");
            this.socket.disconnect();
        }
    },
};
</script>

<style scoped>
.chat-body {
    background-color: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-height: 200px;
    max-height: 250px;
    overflow-y: auto;
    padding: 10px;
}

.message-row {
    display: flex;
    align-items: flex-end;
}

.message-row.customer .message {
    background-color: #064b1f;
    color: white;
    padding: 10px 14px;
    border-radius: 0px 12px 12px 12px;
    margin-left: 10px;
    max-width: 60%;
}

.message-row.agent {
    flex-direction: row-reverse;
}

.message-row.agent .message {
    background-color: #f2f2f2;
    color: black;
    padding: 10px 14px;
    border-radius: 12px 0px 12px 12px;
    margin-right: 10px;
    max-width: 60%;
}

.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.chat-input {
    display: flex;
    padding: 10px;
    border-top: 1px solid #ccc;
}

.chat-input input {
    background-color: #dcdcdc;
    flex: 1;
    border-radius: 6px;
    outline: none;
    padding: 10px;
    margin-right: 10px;
    font-size: 14px;
    border: none;
}

.chat-input button {
    color: black;
    border: 1px solid #064b1f;
    border-radius: 26px;
    padding: 0 13px;
    font-size: 14px;
    cursor: pointer;
    background: white;
}
</style>
